import { StyleSheet, View } from "react-native";
import React from "react";
import { EventDetails, GroupTicketDetails } from "features/types";
import { Text } from "@ui-kitten/components";
import ProfileAvatar from "components/ProfileAvatar";
import env from "config/env";
import { MaterialCommunityIcons } from "@expo/vector-icons";
import { useAppSelector } from "hooks/useAppSelector";
import { selectThemeColor } from "features/slices/tenantSlice";

interface GuestTicketProps {
  groupTicket: GroupTicketDetails;
  event: EventDetails;
}
const GuestTicketRenderItem: React.FC<GuestTicketProps> = (props) => {
  const { groupTicket, event } = props;
  const {
    seat: { sectionDisplay, rowDisplay, seatDisplay, ga },
    firstName,
    lastName,
    planPackageComponentName,
    profileImageIdentifier,
    reservedByAccountId,
    accountId,
  } = groupTicket;
  const { tenantSubdomain } = event;
  const theme = useAppSelector(selectThemeColor);
  const userImageURL = (imageIdentifier: string) =>
    env.fileUrl.replace("tenantSubdomain", tenantSubdomain!) +
    `/${imageIdentifier}`;

  const inviteAccepted = reservedByAccountId !== accountId;
  return (
    <View style={styles.wrapperStyle}>
      {inviteAccepted ? (
        <Text category="h6">
          {firstName} {lastName}
        </Text>
      ) : (
        <Text>{planPackageComponentName}</Text>
      )}

      {profileImageIdentifier && event !== undefined ? (
        <ProfileAvatar
          hasImageIdentifier={profileImageIdentifier !== null}
          size={80}
          source={{ uri: userImageURL(profileImageIdentifier) }}
        ></ProfileAvatar>
      ) : (
        <MaterialCommunityIcons
          size={80}
          color={theme}
          name="account"
        ></MaterialCommunityIcons>
      )}
      <Text>Status: {inviteAccepted ? "Accepted" : "Pending"}</Text>

      {ga ? (
        <Text category="c1">GA</Text>
      ) : (
        <Text category="c1">
          Section: {sectionDisplay} Row: {rowDisplay} Seat: {seatDisplay}
        </Text>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  wrapperStyle: {
    justifyContent: "center",
    alignItems: "center",
    padding: 15,
    backgroundColor: "white",
    borderRadius: 6,
    borderColor: "black",
  },
});
export default GuestTicketRenderItem;
